export enum TenantFeatureGatesEnum {
  OutgoingCallerId = 'OutgoingCallerId',
  EnableCustomOutboundCallerId = 'EnableCustomOutboundCallerId',
  EnableVoiceAgentForContactCenterPro = 'EnableVoiceAgentForContactCenterPro',
}
